import { RenderCheckboxInput } from "app/common/renderInput";
import usePagePermission from "app/hooks/usePagePermission";
import menuService from "app/services/menuService";
import Tooltip from "rc-tooltip";
import React from "react";

import { OverlayTrigger, Popover, Row } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";

function EditPopOver({
  editTarget,
  setEditTarget,
  setIsEditShow,
  isEditShow,
  id,
  childMenus,
  handleSubmit,
  item,
  parent,
}) {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();
  //console.log({ canView, canAdd, canEdit, canDelete });
  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      show={isEditShow}
      overlay={
        <Popover id="popover-basic" style={{ width: 300, zIndex: 500 }}>
          <Popover.Header as="h3">Edit Menu</Popover.Header>
          <Popover.Body>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                defaultValue={item?.name}
                placeholder="Menu name"
                className="my-2 form-control"
              />
              <input
                type="text"
                name="icon"
                defaultValue={item?.icon}
                placeholder="Menu icon"
                className="my-2 form-control"
              />

              {parent && childMenus?.length == 0 && (
                <input
                  type="text"
                  name="path"
                  defaultValue={item?.path ? item?.path : ""}
                  placeholder="Path"
                  className="mt-2 form-control mb-2"
                />
              )}
              {!parent && (
                <input
                  type="text"
                  name="path"
                  defaultValue={item?.path ? item?.path : ""}
                  placeholder="Path"
                  className="mt-2 form-control mb-2"
                />
              )}

              <input
                type="text"
                name="description"
                defaultValue={item?.description}
                placeholder="Description"
                className="mt-2 form-control mb-2"
              />
              <div className="form-check form-switch d-none">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  name="isActive"
                  defaultChecked={item?.isActive}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  Active
                </label>
              </div>
              <input type="hidden" value={id} name="id" />
              <div className="d-flex justify-content-center">
                <div className="m-auto">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger mx-1"
                    onClick={() => setIsEditShow(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-sm btn-outline-primary"
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          </Popover.Body>
        </Popover>
      }
    >
      {canEdit ? (
        <button
          className="btn btn-link btn-sm"
          type="button"
          onClick={(e) => {
            setEditTarget(e.target);
            setIsEditShow(true);
          }}
        >
          <FaEdit />
        </button>
      ) : (
        <></>
      )}
    </OverlayTrigger>
  );
}

export default EditPopOver;
